import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appPreventScrollPropagation]',
})
export class PreventScrollPropagationDirective {
  @Input('appPreventScrollPropagation') isActive = true; // Accepts input

  constructor(private el: ElementRef) {}

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    if (!this.isActive) return;

    const el = this.el.nativeElement;
    const isScrollable = el.scrollHeight > el.clientHeight;
    const atTop = el.scrollTop === 0;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight;

    const scrollingDown = event.deltaY > 0;
    const scrollingUp = event.deltaY < 0;

    if ((scrollingDown && atBottom) || (scrollingUp && atTop) || !isScrollable) {
      event.preventDefault(); // Stop the scroll from propagating to the page
    }
  }
}
